export const ROUTES = {
  LOGIN: "/login",
  ROOT: "/",
  PROFILE: "/profile",
  PHASE_1: "/phase/1",
  PHASE_2: "/phase/2",
  PHASE_3: "/phase/3",
  PHASE_4: "/phase/4",
  PHASE_5: "/phase/5",
  PHASE_7: "/phase/7",
  // PHASE_7_PREVIEW: "/phase/7-preview",
  PHASE_7_TESTING: "/phase/7-testing",
  PHASE_8: "/phase/8",
  PHASE_9: "/phase/9",
  PHASE_10: "/phase/10",
  INTEGRATIONS: "/integrations",
  CONFIG: "/config",
  LOGS: "/logs",
  USERS: "/users",
};
